import { render } from "./CustomAlert.vue?vue&type=template&id=406bd2a2&scoped=true"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"

import "./CustomAlert.vue?vue&type=style&index=0&id=406bd2a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406bd2a2"]])

export default __exports__